import { jsx } from 'react/jsx-runtime';
import { ResourceDataContextProvider } from '../../../resource-detail/components/context/ResourceDataContextProvider.js';
import { ResourcePreviewGridItem } from './ResourcePreviewGrid/ResourcePreviewGridItem.js';

const ResourcePreview = ({ draggableRef, onMouseDown, resource, ...rest }) => {
  return /* @__PURE__ */ jsx(ResourceDataContextProvider, {
    resource,
    parentColorLabels: rest.colorLabels,
    children: /* @__PURE__ */ jsx(ResourcePreviewGridItem, {
      ...rest,
      draggableRef,
      onMouseDown
    })
  });
};

export { ResourcePreview };
//# sourceMappingURL=ResourcePreview.js.map
